export const deleteSearchParam = (search, param) => {
  const searchParam = new URLSearchParams(search);
  param.forEach(el => {
    searchParam.delete(el);
  });

  return searchParam.toString();
};
